import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { saveToken } from "@/lib/tokenStore";

export default function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      saveToken(res.data.token);
      onLogin(res.data.token);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050607] grid place-items-center px-6">
      <form
        onSubmit={submit}
        className="surface p-8 w-full max-w-md"
        data-testid="admin-login-form"
      >
        <div className="flex flex-col items-start gap-1 mb-6">
          <span className="font-display text-xl tracking-widest">PINE</span>
          <span className="font-display text-xl tracking-widest -mt-1">SYSTEMS</span>
          <span className="h-px w-10 bg-[#18E096] mt-1" />
          <span className="overline mt-4">Admin · Leads</span>
        </div>
        <label className="field-label">Passwort</label>
        <div className="relative">
          <Lock
            size={16}
            strokeWidth={1.5}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-[#AEB7B7]"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="field pl-10"
            required
            data-testid="admin-password-input"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="btn-primary mt-6 w-full justify-center disabled:opacity-50"
          data-testid="admin-login-submit"
        >
          {loading ? (
            <Loader2 size={16} strokeWidth={1.5} className="animate-spin" />
          ) : (
            "Anmelden"
          )}
        </button>
        <Link
          to="/"
          className="block text-center text-xs text-[#AEB7B7] mt-4 hover:text-white"
        >
          ← Zurück zur Website
        </Link>
      </form>
    </div>
  );
}
